import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { usePrevious } from "../../../../../hooks/usePrevious";
import { queryKeyEqual } from "../helpers/queryKeyEqual";
import { useEvent } from "../../../../../hooks/useEvent";
import { useLayoutEffect } from "react";


export const useUpdateOnUnmount = <T>(queryKey: any[], getUpdatedData: () => Promise<T>, updateCache: (data: T, queryClient: QueryClient) => void) => {
    const prevQueryKey = usePrevious(queryKey, false);
    const queryClient = useQueryClient();
    const updateQueryCache = useEvent((data: T) => {
        return updateCache(data, queryClient);
    });

    useLayoutEffect(() => {
        const updater = updateQueryCache;
        if (prevQueryKey && queryKeyEqual(queryKey, prevQueryKey)) {
            getUpdatedData().then(updater);
            return () => {
                getUpdatedData().then(updater);
            };
        }
    }, [getUpdatedData, prevQueryKey, queryKey, updateQueryCache]);
};